import ExternalAPIClient from '../api_external_helper';
import { api } from '../../config';
import * as url from '../data_finance/url_helper';
import qs from 'qs';

const apiClient = new ExternalAPIClient(api.REACT_APP_SPED_DATA_FINANCE_API_URL);

let authToken = null; // Variable para almacenar el token de autenticación

export const authenticate = async (username, password) => {
    try {
        // Autenticar solo si el token no ha sido obtenido previamente
        if (!authToken) {
            const response = await apiClient.authenticate(username, password);
            authToken = response;
        }
    } catch (error) {
        console.error('Error durante la autenticación:', error.message);
        throw error;
    }
};

export const stringifyParams = (params) => qs.stringify(params, { encodeValuesOnly: true });

export const getDataFinance = async (data) => {
    try {
        await authenticate(data.username, data.password);
        
        const queryParams = {
            start: data.start,
            end: data.end,
            type: data.type,
            specie: data.specie,
            time_group: data.time_group,
            group_by: data.group_by
        };

        const queryString = stringifyParams(queryParams);
        const urlWithParams = `${url.DATA_FINANCE_FARMGATE_GRAPH}?${queryString}`; 

        return await apiClient.get(urlWithParams, { headers: { Authorization: `Bearer ${authToken}` } });
    } catch (error) {
        console.error('Error al obtener los datos financieros:', error.message);
        throw error;
    }
};

export const clearAuthToken = () => {
    authToken = null; // Función para limpiar el token, si es necesario
};
